import dayjs from "dayjs"
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);
const guessedTimezone = dayjs.tz.guess();

export const getTimeZone = (data: any) => {
    return dayjs(data).isValid() ? dayjs()
    .tz(guessedTimezone)
    .format("z") : "none"
}

